export default {
  text_input: {
    note: {
      place_holder: 'Huomautus...',
    },
  },
  buttons: {
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
};
